import React, { useState, useEffect } from "react";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@material-ui/core";
import { SimpleLoading } from "..";
import { profileIconDefault } from "../../../assets/logos/icons";
import SortableHeader from "../sortableHeader/sortableHeader.pure"; // Import the SortableHeader component
import "./gridHL.css"; // Ensure this CSS file includes the necessary styles
import { underlineIcon } from "@progress/kendo-svg-icons";
import CellActions from "./CellActions.pure";

const GridHLNewPure = (props) => {
  const {
    // miscellaneous props
    skip,
    take,
    dataGrid,
    loading,
    minHeight,
    styleGrid,
    changeSort,
    stateSortStart,
    iconAvatar, // if true, then add avatar to the first field
    fieldImg,

    // titles for the columns. (Only up to 5 columns allowed)
    titleCol1,
    titleCol2,
    titleCol3,
    titleCol4,
    titleCol5,

    //field names for the dataItems
    fieldNameCol1,
    fieldNameCol2,
    fieldNameCol3,
    fieldNameCol4,
    fieldNameCol5,

    // headerClassName for all columns
    headerClassNameCol1,
    headerClassNameCol2,
    headerClassNameCol3,
    headerClassNameCol4,
    headerClassNameCol5,

    // width of all the required GridColumns
    widthCol1,
    widthCol2,
    widthCol3,
    widthCol4,
    widthCol5,

    // Column styles
    styleCol1,
    styleCol2,
    styleCol3,
    styleCol4,
    styleCol5,

    // fieldSubtitles
    fieldSubtitleCol1,
    textSubtitle,

    // cell Actions Aux
    onSelectedItem, //Select information item grid
    setShowDetails,
    setNameComponentUser,
    iconOneActive, //Active first icon
    iconTwoActive, //Active two icon
    iconThirdActive, //Active third icon
    iconFourthActive, //Active fourth icon
    iconFifthActive, //Active fifth icon
    iconTrashActive, // Active trash icon
    labelOneActions, //Label first icon
    labelTwoActions, //Label second icon, first option
    labelTwoActions2, //Label second icon, second option
    labelThirdActions, //Label third icon
    labelFourthActions, //Label fourth icon
    labelFifthActions, //Label fifth icon
    labelTrashActions, //Label trash icon
    activeDialog1, //True to active dialog and false to change page
    btnOpenDialog1, //Function to open dialog in cellAction
    iconOneActiveSelected, //True or false if you use value from array
    iconTwoActiveSelected, //Active one button item, True or false if you use value from array
    showDialogYesNo, //Value true or false, to dialog
    activeDialog2, //Function to open dialog on second btn in cellAction
    btnOpenDialog2, //Function to open dialog on second btn in cellAction
    showDialogYesNo2, //Value true or false, to dialog on second btn,
    paddingBtns, //True or false if want padding between btns
    mobileFunction,
    tooltipTrashIcon, // Trash icon tooltip text
    activeDialogTrash, //True to open dialog and false to change page
    btnOpenDialogTrash, //Function to open dialog on trash icon
    showDialogYesNoTrash, //Value true or false, for dialog on trash icon

    widthHeader
  } = props;
  const { t } = useTranslation();
  const mobileResolution = useMediaQuery("(max-width:720px)");
  const [selectedItem, setSelectedItem] = useState({});
  const initialDataState = {
    skip,
    take,
  };
  const notAllWidthsSet = !widthCol1 && !widthCol2 && !widthCol3 && !widthCol4 && !widthCol5
  const [page, setPage] = useState(initialDataState);

  const onPageChange = (event) => {
    setPage(event.page);
  };

  useEffect(() => {
    onSelectedItem(selectedItem);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);

  const gridSignatureRequestPanelStyle = {
    minHeight: minHeight,
    fontFamily: "Quicksand, sans-serif",
    ...styleGrid,
  };

  const gridColumnNoRecordsStyle = {
    color: "#2C353C",
    fontSize: "16px",
    fontWeight: 550,
    fontFamily: "Quicksand",
  };

  const pagerSettings = {
    info: true,
    buttonCount: 3,
    type: "numeric",
    previousNext: true,
    pageSizes: false,
  }


  const headerStyles = {
    color: "#3B444D",
    fontSize: "14px",
    display: "flex",
    padding: 10,
    fontWeight: "600",
    justifyContent: mobileResolution ? "end" : "start",
    fontFamily: "Quicksand"
  };

  const CellActionsAux = (props) => {
    return <CellActions
      setSelectedItem={setSelectedItem}
      setShowDetails={setShowDetails}
      setNameComponentUser={setNameComponentUser}
      iconOneActive={iconOneActive}
      iconTwoActive={iconTwoActive}
      iconThirdActive={iconThirdActive}
      iconFourthActive={iconFourthActive}
      iconFifthActive={iconFifthActive}
      iconTrashActive={iconTrashActive}
      labelOneActions={labelOneActions}
      labelTwoActions={labelTwoActions}
      labelTwoActions2={labelTwoActions2}
      labelThirdActions={labelThirdActions}
      labelFourthActions={labelFourthActions}
      labelFifthActions={labelFifthActions}
      labelTrashActions={labelTrashActions}
      styleCol4={styleCol4}
      activeDialog1={activeDialog1}
      btnOpenDialog1={btnOpenDialog1}
      iconOneActiveSelected={iconOneActiveSelected}
      iconTwoActiveSelected={iconTwoActiveSelected}
      showDialogYesNo={showDialogYesNo}
      activeDialog2={activeDialog2}
      btnOpenDialog2={btnOpenDialog2}
      showDialogYesNo2={showDialogYesNo2}
      paddingBtns={false}
      mobileFunction={false}
      tooltipTrashIcon={tooltipTrashIcon}
      activeDialogTrash={activeDialogTrash}
      btnOpenDialogTrash={btnOpenDialogTrash}
      showDialogYesNoTrash={showDialogYesNoTrash}
      {...props}
    />
  }

  const avatarCell = (props) => {
    return (
      <td>
        <div className={"gridHLPure-containerAvatar"}>
          {iconAvatar === true ? (
            <div className="gridHLPure-imageAvatar">
              <img
                alt="profile-img"
                src={props.dataItem[fieldImg] || profileIconDefault}
                className="gridHLPure-avatar"
              />
            </div>
          ) : (
            " "
          )}
          <div className={"gridHLPure-containerLabel"}>
            <span className="gridHLPure-userName">
              {props.dataItem[fieldNameCol1] || "----"}
            </span>
            {
              (fieldSubtitleCol1 && textSubtitle) ?
                <div className="gridHLPure-detailsContainer">
                  <span className="gridHLPure-fieldSubtitle">
                    {textSubtitle + props.dataItem[fieldSubtitleCol1]}
                  </span>
                </div>
                : (<div className="gridHLPure-detailsContainer">
                  <span className="gridHLPure-fieldSubtitle">
                    {props.dataItem[fieldSubtitleCol1]}
                  </span>
                </div>)
            }
          </div>
        </div>
      </td>
    );
  };

  const columnTwoCell = (props) => {
    return (
      <td className={styleCol2}>
        {titleCol2 ? (
          <div className="gridHLPure-status">
            <span
              className={
                props.dataItem[fieldNameCol2]
                  ? "gridHLPure-gridActive"
                  : "gridHLPure-gridInactive"
              }
            >
              {props.dataItem[fieldNameCol2] === true ? "Activo" : "Inactivo"}
            </span>
          </div>
        ) : (
          ""
        )}
      </td>
    );
  };

  const HeaderCell = (props) => {
    return <span style={headerStyles}>{props.title}</span>;
  };

  const CustomCell = ({ dataItem, field }) => (
    <td>
      <span>{dataItem[field]}</span>
    </td>
  );

  return loading ? (
    <SimpleLoading />
  ) : (
    <Grid
      className={"gridHLPure"}
      data={dataGrid.slice(page.skip, page.take + page.skip)}
      reorderable
      style={gridSignatureRequestPanelStyle}
      skip={page.skip}
      take={page.take}
      pageable={pagerSettings}
      total={dataGrid.length}
      onPageChange={onPageChange}
    >
      {titleCol1 ?
        (<GridColumn
          field={fieldNameCol1}
          title={titleCol1}
          headerClassName={headerClassNameCol1}
          // set widthcol if all widths are set, set undefined if all widths are not set and set to 
          width={widthCol1 ? widthCol1 : notAllWidthsSet ? undefined : "30%"}
          cell={avatarCell}
          headerCell={HeaderCell}
        />)
        :
        ("")

      }

      {titleCol2 ? (
        <GridColumn
          field={fieldNameCol2}
          title={titleCol2}
          headerClassName={headerClassNameCol2}
          width={widthCol2 ? widthCol2 : notAllWidthsSet ? undefined : "15%"}
          cell={fieldNameCol2 !== "Fecha de alta" ? columnTwoCell : CustomCell}
          headerCell={(props) => (
            <SortableHeader
              title={props.title}
              sortState={stateSortStart}
              onSortChange={() => changeSort(stateSortStart)}
              mobileResolution={mobileResolution}
            />
          )}
          sortState={stateSortStart}
          onSortChange={() => changeSort(stateSortStart)}
        />

      ) : ("")}

      {titleCol3 ? (
        <GridColumn
          field={fieldNameCol3}
          title={titleCol3}
          headerClassName={headerClassNameCol3}
          width={widthCol3 ? widthCol3 : notAllWidthsSet ? undefined : "20%"}
          cell={CustomCell}
          headerCell={(props) => (
            <SortableHeader
              title={props.title}
              sortState={stateSortStart}
              onSortChange={() => changeSort(stateSortStart)}
              mobileResolution={mobileResolution}
            />
          )}
          sortState={stateSortStart}
          onSortChange={() => changeSort(stateSortStart)} />
      ) : ("")}

      {titleCol4 ? (<GridColumn
        field={fieldNameCol4}
        title={titleCol4}
        headerClassName={headerClassNameCol4}
        width={widthCol4 ? widthCol4 : notAllWidthsSet ? undefined : "20%"}
        cell={fieldNameCol4 === "Características" && CustomCell}
        cells={{ data: CellActionsAux }}
        headerCell={HeaderCell}
      />) : ("")}

      {titleCol5 ? (<GridColumn
        field={fieldNameCol5}
        title={titleCol5}
        headerClassName={headerClassNameCol5}
        width={widthCol5 ? widthCol5 : notAllWidthsSet ? undefined : "15%"}
        cell={fieldNameCol5 !== "Acciones" && CustomCell}
        cells={{ data: CellActionsAux }}
        headerCell={HeaderCell}
      />) : ("")}

      <GridNoRecords>
        <span style={gridColumnNoRecordsStyle}>
          {t("configurationDomainPanel.notResults")}
        </span>
      </GridNoRecords>
    </Grid>
  );
};

export default GridHLNewPure;



{/* <GridColumn
field="clientName"
title="Cliente"
width="30%"
cell={CustomCell}
headerCell={HeaderCell}
/>
<GridColumn
field="startDate"
title="Fecha de alta"
width="15%"
cell={CustomCell}
headerCell={(props) => (
  <SortableHeader
    title={props.title}
    sortState={stateSortStart}
    onSortChange={() => changeSort(stateSortStart)}
    mobileResolution={mobileResolution}
  />
)}
sortState={stateSortStart}
onSortChange={() => changeSort(stateSortStart)}
/>
<GridColumn
field="endDate"
title="Fecha límite"
width="20%"
cell={CustomCell}
headerCell={(props) => (
  <SortableHeader
    title={props.title}
    sortState={stateSortStart}
    onSortChange={() => changeSort(stateSortStart)}
    mobileResolution={mobileResolution}
  />
)}
sortState={stateSortStart}
onSortChange={() => changeSort(stateSortStart)} />
<GridColumn
field="status"
title="Características"
width="20%"
cell={CustomCell}
headerCell={HeaderCell}
/>
<GridColumn
field="actions"
title="Acciones"
width="15%"
cell={props => (
  <td>
    <button>Retirar apoyo</button>
  </td>
)}
headerCell={HeaderCell}
/>
<GridNoRecords>
<span style={gridColumnNoRecordsStyle}>
  {t("configurationDomainPanel.notResults")}
</span>
</GridNoRecords> */}